import { EuiFlexGroup, EuiText } from '@elastic/eui'
import { EuiSpacer } from '@elastic/eui'
import { EuiTitle } from '@elastic/eui'

interface SummarySectionProps {
  title: string
  content: string | React.ReactNode
}

export const SummarySectionOld = ({ title, content }: SummarySectionProps) => (
  <div>
    <EuiFlexGroup direction='row' justifyContent='spaceBetween' alignItems='center'>
      <EuiTitle size={'xs'}>
        <p>{title}</p>
      </EuiTitle>
    </EuiFlexGroup>
    <EuiSpacer size={'m'} />
    <EuiText style={{ whiteSpace: 'pre-wrap' }}>{content}</EuiText>
    <EuiSpacer size={'xl'} />
  </div>
)
